<template>
  <div class="card">
    <h5 class="card-header bg-primary text-white">Interview Details</h5>
    <div class="card-body">
      <form>
        <div class="form-row">
          <div class="col-12 col-lg-6">
            <div class="form-group row">
              <label class="col-6 col-lg-4 col-form-label">Country</label>
              <input type="text" class="col-6 col-lg-8 form-control-plaintext" readonly placeholder="---" :disabled="isLoading" v-model="country.displayName" />
            </div>
            <div class="form-group row">
              <label class="col-6 col-lg-4 col-form-label">State</label>
              <input type="text" class="col-6 col-lg-8 form-control-plaintext" readonly placeholder="---" :disabled="isLoading" v-model="state.displayName" />
            </div>
            <div class="form-group row">
              <label class="col-6 col-lg-4 col-form-label">Facility/Store</label>
              <input
                type="text"
                class="col-6 col-lg-8 form-control-plaintext"
                readonly
                placeholder="---"
                :disabled="isLoading"
                v-model="organizationFacility.displayName"
              />
            </div>
            <div class="form-group row">
              <label class="col-6 col-lg-4 col-form-label">Function/District</label>
              <input
                type="text"
                class="col-6 col-lg-8 form-control-plaintext"
                readonly
                placeholder="---"
                :disabled="isLoading"
                v-model="organizationFunction.displayName"
              />
            </div>
            <div class="form-group row">
              <label class="col-6 col-lg-4 col-form-label">Region</label>
              <input
                type="text"
                class="col-6 col-lg-8 form-control-plaintext"
                readonly
                placeholder="---"
                :disabled="isLoading"
                v-model="organizationRegion.displayName"
              />
            </div>
            <div class="form-group row">
              <label class="col-6 col-lg-4 col-form-label">Company/Division</label>
              <input
                type="text"
                class="col-6 col-lg-8 form-control-plaintext"
                readonly
                placeholder="---"
                :disabled="isLoading"
                v-model="organizationCompany.displayName"
              />
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group row">
              <table class="table mt-4 mt-md-0">
                <thead>
                  <tr>
                    <th scope="col">Category</th>
                    <th scope="col" class="text-center">Emphasized</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="category in investigation.interviewCategories" :key="category.id">
                    <td>{{ category.displayName }}</td>
                    <td class="text-center">
                      <fa icon="check" fixed-width v-if="category.isEmphasized" />
                      <span v-if="!category.isEmphasized" class="text-muted">---</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import formatter from "@/utils/formatter";

export default {
  props: {
    isLoading: Boolean,
    investigation: Object,
  },
  computed: {
    formatter: () => formatter,
    country() {
      return this.investigation.country ? this.investigation.country : {};
    },
    state() {
      return this.investigation.state ? this.investigation.state : {};
    },
    organizationFacility() {
      return this.investigation.organizationFacility ? this.investigation.organizationFacility : {};
    },
    organizationFunction() {
      return this.investigation.organizationFunction ? this.investigation.organizationFunction : {};
    },
    organizationRegion() {
      return this.investigation.organizationRegion ? this.investigation.organizationRegion : {};
    },
    organizationCompany() {
      return this.investigation.organizationCompany ? this.investigation.organizationCompany : {};
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/base.scss";

.form-group {
  margin-bottom: 0;
}

input[readonly="readonly"] {
  outline: 0px transparent;
}

textarea[readonly="readonly"] {
  outline: 0px transparent;
}
</style>
